import { Button, Card, CardContent, Paper, Stack, TextField, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import { useCreatePermissionMutation, useGetPermissionQuery, useListPermissionsQuery } from '../../features/model/permissionSlice';
import { useGetPersonPermissionsQuery } from '../../features/model/personSlice';
import { useCreatePersonPermissionMutation, useDeletePersonPermissionMutation } from '../../features/model/personpermissionSlice';


const PermissionCard = ({permission=null, permission_id=null, onClick, buttonText="Add"}) => {
    const getperm = useGetPermissionQuery(permission_id, {skip: permission!=null || permission_id==null})
    if(!permission && getperm.isLoading) {
        return <Loading />
    }
    const loaded_perm = permission != null ? permission : getperm.data;

    return <Card variant="outlined" sx={{ width: 250 }}>
        <CardContent sx={{padding: "3px"}}>
            <Stack direction="row" justifyContent={"space-between"}>
            <Typography sx={{alignSelf: "center"}}>{loaded_perm.name}</Typography>
            {onClick && <Button variant="outlined" onClick={() => {onClick(loaded_perm)}}>{buttonText}</Button>}
            </Stack>
        </CardContent>
    </Card>;
}

const AllPermissionsView = ({onClick=null}) => {
    const perms = useListPermissionsQuery();
    const [createPermission] = useCreatePermissionMutation();
    
    if (perms.isLoading || !perms.data) {
        return <Loading />;
    }

    if (perms.error) {
        return <div>Error: {perms.error.error}</div>
    }

    return <Stack sx={{margin: 2}} spacing={2}>
        {perms.data.objects.map((permission) => <PermissionCard key={permission.id} permission={permission} onClick={onClick} />)}
        <Typography variant="h4">Create new permission</Typography>
        <TextField
              sx={{marginTop: 2}}
              placeholder='Type and press enter...'
              onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    createPermission({name: e.target.value});
                    e.target.value = "";
                  }
              }}
        />
    </Stack>
}

const PersonPermissionsView = ({person}) => {
    const personperms = useGetPersonPermissionsQuery(person.id);
    const [deletePersonPermission] = useDeletePersonPermissionMutation();
    const [createPersonPermission] = useCreatePersonPermissionMutation();

    if (personperms.isLoading || !personperms.data) {
        return <Loading />
    }

    console.log(personperms.data.objects);

    return <Stack direction="row">
        <Stack sx={{margin: 2}} spacing={2}>
            <Paper>
            <Card>
                <Stack direction="column" sx={{margin: 2}} spacing={2}>
                    <Typography variant="h2">User Permissions</Typography>
                    {personperms.data.objects.map((perper) => <PermissionCard key={perper.permission.id} permission_id={perper.permission} onClick={(perm) => {
                        deletePersonPermission(perper.id);
                    }} buttonText="Remove" />)}
                </Stack>
            </Card>
            </Paper>
        </Stack>
        <Stack sx={{margin: 2}} spacing={2}>
            <Paper>
            <Card>
                <Stack direction="column" sx={{margin: 2}} spacing={2}>
                    <Typography variant="h2">All available permissions</Typography>
                    <AllPermissionsView onClick={(perm) => {
                        createPersonPermission({
                            person: person.id,
                            permission: perm.id
                        })
                    }}/>
                </Stack>
            </Card>
            </Paper>
        </Stack>

    </Stack>

}

export { AllPermissionsView, PersonPermissionsView };